// // import React, { useState, useEffect, useRef } from 'react';
// // import { ChevronLeft, ChevronRight } from 'lucide-react';

// // const OffersSection = ({ isMobile, vendorId = 2 }) => {
// //     const [currentIndex, setCurrentIndex] = useState(0);
// //     const [touchStart, setTouchStart] = useState(0);
// //     const [touchEnd, setTouchEnd] = useState(0);
// //     const [offers, setOffers] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const [resetting, setResetting] = useState(false);
// //     const [error, setError] = useState(null);
// //     const carouselRef = useRef(null);

// //     // API endpoint
// //     const API_BASE_URL = 'https://backend.maamaas.com/food/api/vendor/coupon/getByVendor';
    
// //     // Fetch offers from API
// //     const fetchOffersData = async () => {
// //         if (!vendorId) return;
        
// //         setResetting(true);
// //         setLoading(true);
// //         setError(null);
        
// //         try {
// //             const token = localStorage.getItem("authToken");
// //             if (!token) {
// //                 setError("Authentication required. Please log in.");
// //                 setLoading(false);
// //                 setResetting(false);
// //                 return;
// //             }

// //             //console.log('Fetching offers for vendor:', vendorId);
            
// //             const response = await fetch(`${API_BASE_URL}/${vendorId}`, {
// //                 method: 'GET',
// //                 headers: {
// //                     'Content-Type': 'application/json',
// //                     'Accept': 'application/json',
// //                     'Authorization': `Bearer ${token}`
// //                 },
// //                 credentials: 'include'
// //             });

// //             //console.log('Response status:', response.status);
            
// //             if (response.status === 401 || response.status === 403) {
// //                 throw new Error('Access denied. Please check your authentication.');
// //             }
            
// //             if (response.status === 404) {
// //                 throw new Error('Vendor not found or no offers available.');
// //             }
            
// //             if (!response.ok) {
// //                 throw new Error(`HTTP error! status: ${response.status}`);
// //             }

// //             const data = await response.json();
// //             //console.log('API Response data:', data);
            
// //             // Check if data is an array
// //             if (!Array.isArray(data)) {
// //                 throw new Error('Invalid response format: expected an array');
// //             }
            
// //             if (data.length === 0) {
// //                 setOffers([]);
// //                 setLoading(false);
// //                 setResetting(false);
// //                 return;
// //             }
            
// //             // Transform API data
// //             const transformedOffers = data.map((offer, index) => ({
// //                 id: offer.vendorRequirementCouponId || offer.id || index,
// //                 image: offer.image 
// //                     ? (offer.image.startsWith('data:image') 
// //                         ? offer.image 
// //                         : `data:image/jpeg;base64,${offer.image}`)
// //                     : getDefaultImage(offer.couponCode || offer.name || `Offer ${index}`),
// //                 name: offer.couponCode || offer.description || `Special Offer ${index + 1}`,
// //                 discount: `${offer.discount || 0}% OFF`,
// //                 description: offer.description || '',
// //                 startDate: offer.startDate,
// //                 endDate: offer.endDate,
// //                 amount: offer.amount,
// //                 paymentStatus: offer.paymentStatus,
// //                 originalData: offer
// //             }));
            
// //             //console.log('Transformed offers:', transformedOffers);
// //             setOffers(transformedOffers);
// //             setError(null);
            
// //         } catch (err) {
// //             console.error('Error fetching offers:', err);
// //             setError(err.message || 'Failed to load offers. Please try again later.');
            
// //             // Use fallback data if API fails
// //             setOffers(getFallbackOffers());
// //         } finally {
// //             setLoading(false);
// //             setResetting(false);
// //         }
// //     };

// //     // Initial fetch
// //     useEffect(() => {
// //         fetchOffersData();
// //     }, [vendorId]);

// //     // Get default image
// //     const getDefaultImage = (name) => {
// //         const foodImages = [
// //             "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&auto=format&fit=crop",
// //             "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&auto=format&fit=crop",
// //             "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=800&auto=format&fit=crop",
// //             "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&auto=format&fit=crop",
// //             "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800&auto=format&fit=crop"
// //         ];
        
// //         const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
// //         return foodImages[hash % foodImages.length];
// //     };

// //     // Fallback offers
// //     const getFallbackOffers = () => [
// //         {
// //             id: 1,
// //             image: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&auto=format&fit=crop",
// //             name: "Grilled Salmon",
// //             discount: "20% OFF",
// //             description: "Fresh grilled salmon with herbs"
// //         },
// //         {
// //             id: 2,
// //             image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&auto=format&fit=crop",
// //             name: "Margherita Pizza",
// //             discount: "15% OFF",
// //             description: "Classic pizza with fresh mozzarella"
// //         },
// //         {
// //             id: 3,
// //             image: "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=800&auto=format&fit=crop",
// //             name: "Butter Chicken",
// //             discount: "25% OFF",
// //             description: "Creamy butter chicken with naan"
// //         }
// //     ];

// //     // Auto-rotate offers
// //     useEffect(() => {
// //         if (offers.length <= 3 || loading || resetting) return;
        
// //         const interval = setInterval(() => {
// //             setCurrentIndex((prevIndex) => 
// //                 prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
// //             );
// //         }, 4000);

// //         return () => clearInterval(interval);
// //     }, [offers.length, loading, resetting]);

// //     // Navigation
// //     const nextSlide = () => {
// //         if (offers.length <= 3) return;
// //         setCurrentIndex((prevIndex) => 
// //             prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
// //         );
// //     };

// //     const prevSlide = () => {
// //         if (offers.length <= 3) return;
// //         setCurrentIndex((prevIndex) => 
// //             prevIndex === 0 ? Math.max(offers.length - 3, 0) : prevIndex - 1
// //         );
// //     };

// //     // Touch handlers
// //     const handleTouchStart = (e) => {
// //         setTouchStart(e.targetTouches[0].clientX);
// //     };

// //     const handleTouchMove = (e) => {
// //         setTouchEnd(e.targetTouches[0].clientX);
// //     };

// //     const handleTouchEnd = () => {
// //         if (touchStart - touchEnd > 75) nextSlide();
// //         if (touchStart - touchEnd < -75) prevSlide();
// //     };

// //     // Get visible offers
// //     const getVisibleOffers = () => {
// //         if (offers.length <= 3) return offers;
        
// //         const visibleOffers = offers.slice(currentIndex, currentIndex + 3);
        
// //         if (visibleOffers.length < 3) {
// //             visibleOffers.push(...offers.slice(0, 3 - visibleOffers.length));
// //         }
        
// //         return visibleOffers;
// //     };

// //     const visibleOffers = getVisibleOffers();

// //     // Loading state
// //     if (loading || resetting) {
// //         return (
// //             <div style={{
// //                 marginBottom: '32px',
// //                 padding: isMobile ? '0 16px' : '0 24px',
// //                 textAlign: 'center',
// //                 minHeight: '300px',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center'
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     flexDirection: 'column',
// //                     alignItems: 'center',
// //                     gap: '12px'
// //                 }}>
// //                     <div style={{
// //                         width: '40px',
// //                         height: '40px',
// //                         border: '3px solid #f3f3f3',
// //                         borderTop: '3px solid #FF6B35',
// //                         borderRadius: '50%',
// //                         animation: 'spin 1s linear infinite'
// //                     }}></div>
// //                     <style>{`
// //                         @keyframes spin {
// //                             0% { transform: rotate(0deg); }
// //                             100% { transform: rotate(360deg); }
// //                         }
// //                     `}</style>
// //                     <div style={{ color: '#666' }}>
// //                         {resetting ? 'Refreshing offers...' : 'Loading offers...'}
// //                     </div>
// //                 </div>
// //             </div>
// //         );
// //     }

// //     // Error state when no offers
// //     if (error && offers.length === 0) {
// //         return (
// //             <div style={{
// //                 marginBottom: '32px',
// //                 padding: isMobile ? '0 16px' : '0 24px',
// //                 textAlign: 'center',
// //                 minHeight: '300px',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 flexDirection: 'column',
// //                 gap: '12px'
// //             }}>
// //                 <div style={{ 
// //                     color: '#EF4444',
// //                     fontWeight: '600',
// //                     marginBottom: '10px' 
// //                 }}>
// //                     ⚠️ {error}
// //                 </div>
// //                 <div style={{ 
// //                     fontSize: '14px',
// //                     color: '#6B7280'
// //                 }}>
// //                     Showing demo offers
// //                 </div>
// //                 <button
// //                     onClick={fetchOffersData}
// //                     style={{
// //                         marginTop: '10px',
// //                         padding: '8px 16px',
// //                         backgroundColor: '#FF6B35',
// //                         color: 'white',
// //                         border: 'none',
// //                         borderRadius: '8px',
// //                         cursor: 'pointer',
// //                         fontSize: '14px',
// //                         fontWeight: '600'
// //                     }}
// //                 >
// //                     Retry
// //                 </button>
// //             </div>
// //         );
// //     }

// //     // Render component
// //     return (
// //         <div style={{
// //             marginBottom: '32px',
// //             padding: isMobile ? '0 16px' : '0 24px'
// //         }}>
// //             {/* Header with refresh button */}
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'center',
// //                 marginBottom: '16px'
// //             }}>
// //                 <h2 style={{
// //                     fontSize: '24px',
// //                     fontWeight: '700',
// //                     color: '#1F2937',
// //                     margin: 0
// //                 }}>
// //                     Special Offers
// //                 </h2>
// //                 {/* <button
// //                     onClick={fetchOffersData}
// //                     disabled={resetting}
// //                     style={{
// //                         padding: '8px 16px',
// //                         backgroundColor: resetting ? '#9CA3AF' : '#FF6B35',
// //                         color: 'white',
// //                         border: 'none',
// //                         borderRadius: '8px',
// //                         cursor: resetting ? 'not-allowed' : 'pointer',
// //                         fontSize: '14px',
// //                         fontWeight: '600',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '6px'
// //                     }}
// //                 >
// //                     {resetting ? (
// //                         <>
// //                             <span style={{
// //                                 display: 'inline-block',
// //                                 width: '12px',
// //                                 height: '12px',
// //                                 border: '2px solid white',
// //                                 borderTopColor: 'transparent',
// //                                 borderRadius: '50%',
// //                                 animation: 'spin 1s linear infinite'
// //                             }}></span>
// //                             Refreshing
// //                         </>
// //                     ) : 'Refresh Offers'}
// //                 </button> */}
// //             </div>

// //             {/* Error banner */}
// //             {error && offers.length > 0 && (
// //                 <div style={{
// //                     backgroundColor: '#FEF3C7',
// //                     border: '1px solid #F59E0B',
// //                     borderRadius: '8px',
// //                     padding: '12px',
// //                     marginBottom: '16px',
// //                     fontSize: '14px',
// //                     color: '#92400E',
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center'
// //                 }}>
// //                     <span>⚠️ {error} (Showing cached offers)</span>
// //                     <button
// //                         onClick={fetchOffersData}
// //                         style={{
// //                             background: 'none',
// //                             border: '1px solid #F59E0B',
// //                             color: '#92400E',
// //                             padding: '4px 8px',
// //                             borderRadius: '4px',
// //                             cursor: 'pointer',
// //                             fontSize: '12px'
// //                         }}
// //                     >
// //                         Retry
// //                     </button>
// //                 </div>
// //             )}

// //             {/* Carousel Container */}
// //             <div style={{
// //                 position: 'relative',
// //                 overflow: 'hidden',
// //                 borderRadius: '20px',
// //                 marginBottom: '20px'
// //             }}
// //             ref={carouselRef}
// //             onTouchStart={handleTouchStart}
// //             onTouchMove={handleTouchMove}
// //             onTouchEnd={handleTouchEnd}
// //             >
            
// //                 {/* Offers Grid */}
// //                 <div style={{
// //                     display: 'grid',
// //                     gridTemplateColumns: isMobile ? '1fr' : offers.length <= 2 ? `repeat(${Math.min(offers.length, 3)}, 1fr)` : 'repeat(3, 1fr)',
// //                     gap: '20px',
// //                     padding: '8px'
// //                 }}>
// //                     {visibleOffers.map((offer) => (
// //                         <div
// //                             key={offer.id}
// //                             style={{
// //                                 background: 'white',
// //                                 borderRadius: '16px',
// //                                 overflow: 'hidden',
// //                                 boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //                                 transition: 'all 0.3s ease',
// //                                 cursor: 'pointer',
// //                                 height: '100%'
// //                             }}
// //                             onMouseEnter={(e) => {
// //                                 if (!isMobile) {
// //                                     e.currentTarget.style.transform = 'translateY(-4px)';
// //                                     e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.15)';
// //                                 }
// //                             }}
// //                             onMouseLeave={(e) => {
// //                                 if (!isMobile) {
// //                                     e.currentTarget.style.transform = 'translateY(0)';
// //                                     e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
// //                                 }
// //                             }}
// //                             onClick={() => {
// //                                 //console.log('Offer clicked:', offer);
// //                                 // Add your click handler here
// //                             }}
// //                         >
// //                             {/* Food Image with Overlay */}
// //                             <div style={{
// //                                 height: '300px',
// //                                 position: 'relative',
// //                                 overflow: 'hidden'
// //                             }}>
// //                                 <div style={{
// //                                     position: 'absolute',
// //                                     top: 0,
// //                                     left: 0,
// //                                     right: 0,
// //                                     bottom: 0,
// //                                     backgroundImage: `url(${offer.image})`,
// //                                     backgroundSize: 'cover',
// //                                     backgroundPosition: 'center',
// //                                     transition: 'transform 0.5s ease'
// //                                 }}></div>
                                
// //                                 {/* Gradient Overlay */}
// //                                 <div style={{
// //                                     position: 'absolute',
// //                                     top: 0,
// //                                     left: 0,
// //                                     right: 0,
// //                                     bottom: 0,
// //                                     background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%)'
// //                                 }}></div>
                                
// //                                 {/* Discount Percentage */}
// //                                 <div style={{
// //                                     position: 'absolute',
// //                                     top: '16px',
// //                                     right: '16px',
// //                                     background: 'linear-gradient(135deg, #FF6B35 0%, #FF9E00 100%)',
// //                                     color: 'white',
// //                                     fontSize: '18px',
// //                                     fontWeight: '800',
// //                                     padding: '10px 20px',
// //                                     borderRadius: '20px',
// //                                     boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)'
// //                                 }}>
// //                                     {offer.discount}
// //                                 </div>
                                
// //                                 {/* Item Name */}
// //                                 <div style={{
// //                                     position: 'absolute',
// //                                     bottom: '16px',
// //                                     left: '16px',
// //                                     right: '16px',
// //                                     color: 'white',
// //                                     fontSize: '24px',
// //                                     fontWeight: '800',
// //                                     padding: '12px 20px',
// //                                     textAlign: 'center',
// //                                     textShadow: '0 2px 8px rgba(0,0,0,0.8)'
// //                                 }}>
// //                                     {offer.name}
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     ))}
// //                 </div>
// //             </div>

          

// //             {/* Mobile Instructions */}
// //             {/* {isMobile && offers.length > 1 && (
// //                 <div style={{
// //                     textAlign: 'center',
// //                     fontSize: '12px',
// //                     color: '#6B7280',
// //                     marginTop: '12px',
// //                     padding: '8px',
// //                     backgroundColor: '#F9FAFB',
// //                     borderRadius: '8px'
// //                 }}>
// //                     👆 Swipe left/right to see more offers
// //                 </div>
// //             )} */}
// //         </div>
// //     );
// // };

// // export default OffersSection;





// import React, { useState, useEffect, useRef } from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const OffersSection = ({ isMobile, vendorId = 2 }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [touchStart, setTouchStart] = useState(0);
//     const [touchEnd, setTouchEnd] = useState(0);
//     const [offers, setOffers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [resetting, setResetting] = useState(false);
//     const [error, setError] = useState(null);
//     const carouselRef = useRef(null);

//     // API endpoint
//     const API_BASE_URL = 'https://backend.maamaas.com/food/api/vendor/coupon/getByVendor';
    
//     // Fetch offers from API
//     const fetchOffersData = async () => {
//         if (!vendorId) return;
        
//         setResetting(true);
//         setLoading(true);
//         setError(null);
        
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 setError("Authentication required. Please log in.");
//                 setLoading(false);
//                 setResetting(false);
//                 return;
//             }

            
//             const response = await fetch(`${API_BASE_URL}/${vendorId}`, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Accept': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 credentials: 'include'
//             });

            
//             if (response.status === 401 || response.status === 403) {
//                 throw new Error('Access denied. Please check your authentication.');
//             }
            
//             if (response.status === 404) {
//                 throw new Error('Vendor not found or no offers available.');
//             }
            
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
            
//             // Check if data is an array
//             if (!Array.isArray(data)) {
//                 throw new Error('Invalid response format: expected an array');
//             }
            
//             if (data.length === 0) {
//                 setOffers([]);
//                 setLoading(false);
//                 setResetting(false);
//                 return;
//             }
            
//             // Transform API data
//             const transformedOffers = data.map((offer, index) => ({
//                 id: offer.vendorRequirementCouponId || offer.id || index,
//                 image: offer.image 
//                     ? (offer.image.startsWith('data:image') 
//                         ? offer.image 
//                         : `data:image/jpeg;base64,${offer.image}`)
//                     : getDefaultImage(offer.couponCode || offer.name || `Offer ${index}`),
//                 name: offer.couponCode || offer.description || `Special Offer ${index + 1}`,
//                 discount: `${offer.discount || 0}% OFF`,
//                 description: offer.description || '',
//                 startDate: offer.startDate,
//                 endDate: offer.endDate,
//                 amount: offer.amount,
//                 paymentStatus: offer.paymentStatus,
//                 originalData: offer
//             }));
            
//             setOffers(transformedOffers);
//             setError(null);
            
//         } catch (err) {
//             console.error('Error fetching offers:', err);
//             setError(err.message || 'Failed to load offers. Please try again later.');
            
//             // Don't use fallback data - just show empty state
//             setOffers([]);
//         } finally {
//             setLoading(false);
//             setResetting(false);
//         }
//     };

//     // Initial fetch
//     useEffect(() => {
//         fetchOffersData();
//     }, [vendorId]);

//     // Get default image
//     const getDefaultImage = (name) => {
//         const foodImages = [
//             "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&auto=format&fit=crop",
//             "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&auto=format&fit=crop",
//             "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=800&auto=format&fit=crop",
//             "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&auto=format&fit=crop",
//             "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800&auto=format&fit=crop"
//         ];
        
//         const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
//         return foodImages[hash % foodImages.length];
//     };

//     // Auto-rotate offers
//     useEffect(() => {
//         if (offers.length <= 3 || loading || resetting) return;
        
//         const interval = setInterval(() => {
//             setCurrentIndex((prevIndex) => 
//                 prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
//             );
//         }, 4000);

//         return () => clearInterval(interval);
//     }, [offers.length, loading, resetting]);

//     // Navigation
//     const nextSlide = () => {
//         if (offers.length <= 3) return;
//         setCurrentIndex((prevIndex) => 
//             prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
//         );
//     };

//     const prevSlide = () => {
//         if (offers.length <= 3) return;
//         setCurrentIndex((prevIndex) => 
//             prevIndex === 0 ? Math.max(offers.length - 3, 0) : prevIndex - 1
//         );
//     };

//     // Touch handlers
//     const handleTouchStart = (e) => {
//         setTouchStart(e.targetTouches[0].clientX);
//     };

//     const handleTouchMove = (e) => {
//         setTouchEnd(e.targetTouches[0].clientX);
//     };

//     const handleTouchEnd = () => {
//         if (touchStart - touchEnd > 75) nextSlide();
//         if (touchStart - touchEnd < -75) prevSlide();
//     };

//     // Get visible offers
//     const getVisibleOffers = () => {
//         if (offers.length <= 3) return offers;
        
//         const visibleOffers = offers.slice(currentIndex, currentIndex + 3);
        
//         if (visibleOffers.length < 3) {
//             visibleOffers.push(...offers.slice(0, 3 - visibleOffers.length));
//         }
        
//         return visibleOffers;
//     };

//     const visibleOffers = getVisibleOffers();

//     // Loading state
//     if (loading || resetting) {
//         return (
//             <div style={{
//                 marginBottom: '32px',
//                 padding: isMobile ? '0 16px' : '0 24px',
//                 textAlign: 'center',
//                 minHeight: '300px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     gap: '12px'
//                 }}>
//                     <div style={{
//                         width: '40px',
//                         height: '40px',
//                         border: '3px solid #f3f3f3',
//                         borderTop: '3px solid #FF6B35',
//                         borderRadius: '50%',
//                         animation: 'spin 1s linear infinite'
//                     }}></div>
//                     <style>{`
//                         @keyframes spin {
//                             0% { transform: rotate(0deg); }
//                             100% { transform: rotate(360deg); }
//                         }
//                     `}</style>
//                     <div style={{ color: '#666' }}>
//                         {resetting ? 'Refreshing offers...' : 'Loading offers...'}
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // If no offers and no error (empty state)
//     if (offers.length === 0 && !error) {
//         return null; // Don't render anything if there are no offers
//     }

//     // Error state when API fails but we have fallback offers
//     if (error && offers.length === 0) {
//         return null; // Don't show anything if we have error and no offers
//     }

//     // Only render if we have offers
//     if (offers.length === 0) {
//         return null;
//     }

//     // Render component only when there are offers
//     return (
//         <div style={{
//             marginBottom: '32px',
//             padding: isMobile ? '0 16px' : '0 24px'
//         }}>
//             {/* Header with refresh button - ONLY SHOWS WHEN WE HAVE OFFERS */}
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '16px'
//             }}>
//                 <h2 style={{
//                     fontSize: '24px',
//                     fontWeight: '700',
//                     color: '#1F2937',
//                     margin: 0
//                 }}>
//                     Special Offers
//                 </h2>
//                 {/* Optional: Keep refresh button if needed */}
//                 {/* <button
//                     onClick={fetchOffersData}
//                     disabled={resetting}
//                     style={{
//                         padding: '8px 16px',
//                         backgroundColor: resetting ? '#9CA3AF' : '#FF6B35',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '8px',
//                         cursor: resetting ? 'not-allowed' : 'pointer',
//                         fontSize: '14px',
//                         fontWeight: '600',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px'
//                     }}
//                 >
//                     {resetting ? (
//                         <>
//                             <span style={{
//                                 display: 'inline-block',
//                                 width: '12px',
//                                 height: '12px',
//                                 border: '2px solid white',
//                                 borderTopColor: 'transparent',
//                                 borderRadius: '50%',
//                                 animation: 'spin 1s linear infinite'
//                             }}></span>
//                             Refreshing
//                         </>
//                     ) : 'Refresh Offers'}
//                 </button> */}
//             </div>

//             {/* Error banner - only shows if we have offers but there was an error */}
//             {error && offers.length > 0 && (
//                 <div style={{
//                     backgroundColor: '#FEF3C7',
//                     border: '1px solid #F59E0B',
//                     borderRadius: '8px',
//                     padding: '12px',
//                     marginBottom: '16px',
//                     fontSize: '14px',
//                     color: '#92400E',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center'
//                 }}>
//                     <span>⚠️ {error} (Showing cached offers)</span>
//                     <button
//                         onClick={fetchOffersData}
//                         style={{
//                             background: 'none',
//                             border: '1px solid #F59E0B',
//                             color: '#92400E',
//                             padding: '4px 8px',
//                             borderRadius: '4px',
//                             cursor: 'pointer',
//                             fontSize: '12px'
//                         }}
//                     >
//                         Retry
//                     </button>
//                 </div>
//             )}

//             {/* Carousel Container - ONLY SHOWS WHEN WE HAVE OFFERS */}
//             <div style={{
//                 position: 'relative',
//                 overflow: 'hidden',
//                 borderRadius: '20px',
//                 marginBottom: '20px'
//             }}
//             ref={carouselRef}
//             onTouchStart={handleTouchStart}
//             onTouchMove={handleTouchMove}
//             onTouchEnd={handleTouchEnd}
//             >
            
//                 {/* Offers Grid */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : offers.length <= 2 ? `repeat(${Math.min(offers.length, 3)}, 1fr)` : 'repeat(3, 1fr)',
//                     gap: '20px',
//                     padding: '8px'
//                 }}>
//                     {visibleOffers.map((offer) => (
//                         <div
//                             key={offer.id}
//                             style={{
//                                 background: 'white',
//                                 borderRadius: '16px',
//                                 overflow: 'hidden',
//                                 boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
//                                 transition: 'all 0.3s ease',
//                                 cursor: 'pointer',
//                                 height: '100%'
//                             }}
//                             onMouseEnter={(e) => {
//                                 if (!isMobile) {
//                                     e.currentTarget.style.transform = 'translateY(-4px)';
//                                     e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.15)';
//                                 }
//                             }}
//                             onMouseLeave={(e) => {
//                                 if (!isMobile) {
//                                     e.currentTarget.style.transform = 'translateY(0)';
//                                     e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
//                                 }
//                             }}
//                             onClick={() => {
//                                 // Add your click handler here
//                             }}
//                         >
//                             {/* Food Image with Overlay */}
//                             <div style={{
//                                 height: '300px',
//                                 position: 'relative',
//                                 overflow: 'hidden'
//                             }}>
//                                 <div style={{
//                                     position: 'absolute',
//                                     top: 0,
//                                     left: 0,
//                                     right: 0,
//                                     bottom: 0,
//                                     backgroundImage: `url(${offer.image})`,
//                                     backgroundSize: 'cover',
//                                     backgroundPosition: 'center',
//                                     transition: 'transform 0.5s ease'
//                                 }}></div>
                                
//                                 {/* Gradient Overlay */}
//                                 <div style={{
//                                     position: 'absolute',
//                                     top: 0,
//                                     left: 0,
//                                     right: 0,
//                                     bottom: 0,
//                                     background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%)'
//                                 }}></div>
                                
//                                 {/* Discount Percentage */}
//                                 <div style={{
//                                     position: 'absolute',
//                                     top: '16px',
//                                     right: '16px',
//                                     background: 'linear-gradient(135deg, #FF6B35 0%, #FF9E00 100%)',
//                                     color: 'white',
//                                     fontSize: '18px',
//                                     fontWeight: '800',
//                                     padding: '10px 20px',
//                                     borderRadius: '20px',
//                                     boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)'
//                                 }}>
//                                     {offer.discount}
//                                 </div>
                                
//                                 {/* Item Name */}
//                                 <div style={{
//                                     position: 'absolute',
//                                     bottom: '16px',
//                                     left: '16px',
//                                     right: '16px',
//                                     color: 'white',
//                                     fontSize: '24px',
//                                     fontWeight: '800',
//                                     padding: '12px 20px',
//                                     textAlign: 'center',
//                                     textShadow: '0 2px 8px rgba(0,0,0,0.8)'
//                                 }}>
//                                     {offer.name}
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OffersSection;










import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const OffersSection = ({ isMobile, vendorId = null }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const carouselRef = useRef(null);

    useEffect(() => {
        fetchOffersData();
    }, [vendorId]);

    const fetchOffersData = async () => {

        // Get vendor ID
        const actualVendorId = vendorId || localStorage.getItem('vendorId');
        const token = localStorage.getItem("authToken");

      
        if (!actualVendorId || !token) {
            console.error('Missing vendorId or token');
            setError("Authentication required. Please log in.");
            setLoading(false);
            setOffers([]);
            return;
        }

        setLoading(true);
        setError(null);

        try {

            // Use simpler fetch with timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${actualVendorId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    signal: controller.signal
                }
            );

            clearTimeout(timeoutId);


            if (!response.ok) {
                throw new Error(`API error: ${response.status}`);
            }

            const data = await response.json();

            // Handle response format
            let offersArray = [];
            if (Array.isArray(data)) {
                offersArray = data;
            } else if (data && Array.isArray(data.data)) {
                offersArray = data.data;
            } else if (data && data.success && Array.isArray(data.result)) {
                offersArray = data.result;
            } else {
                throw new Error('Unexpected response format from API');
            }

            // 🔥 FILTER: Only get PAID offers
            const paidOffers = offersArray.filter(offer =>
                offer && offer.paymentStatus === 'PAID'
            );


            if (paidOffers.length === 0) {
                setOffers([]);
                setLoading(false);
                return;
            }

            // Transform data
            const transformedOffers = paidOffers.map((offer, index) => {
                // Create image URL
                let imageUrl;
                if (offer.image && typeof offer.image === 'string' && offer.image.trim().length > 0) {
                    try {
                        let imgStr = offer.image.trim();
                        // Remove leading slash if present
                        if (imgStr.startsWith('/')) {
                            imgStr = imgStr.substring(1);
                        }
                        // Remove whitespace
                        imgStr = imgStr.replace(/\s+/g, '');

                        if (imgStr.length > 50) {
                            imageUrl = `data:image/jpeg;base64,${imgStr}`;
                        } else {
                            imageUrl = getDefaultImage(offer.couponCode);
                        }
                    } catch (imgErr) {
                        console.warn('Image processing error:', imgErr);
                        imageUrl = getDefaultImage(offer.couponCode);
                    }
                } else {
                    imageUrl = getDefaultImage(offer.couponCode);
                }

                return {
                    id: offer.vendorRequirementCouponId || `offer-${index}`,
                    image: imageUrl,
                    name: offer.couponCode || `Special Offer ${index + 1}`,
                    discount: `${offer.discount || 0}% OFF`,
                    description: offer.description || '',
                    startDate: offer.startDate,
                    endDate: offer.endDate,
                    amount: offer.amount,
                    paymentStatus: offer.paymentStatus,
                    originalData: offer
                };
            });

            setOffers(transformedOffers);
            setError(null);

        } catch (err) {
            console.error('Error fetching offers:', err);
            setError(err.message || 'Failed to load offers');
            setOffers([]);
        } finally {
            setLoading(false);
        }
    };

    // Get default image
    const getDefaultImage = (name) => {
        const foodImages = [
            "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=800&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800&auto=format&fit=crop"
        ];

        const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return foodImages[hash % foodImages.length];
    };

    // Auto-rotate offers
    useEffect(() => {
        if (offers.length <= 3 || loading) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
            );
        }, 4000);

        return () => clearInterval(interval);
    }, [offers.length, loading]);

    // Navigation
    const nextSlide = () => {
        if (offers.length <= 3) return;
        setCurrentIndex((prevIndex) =>
            prevIndex >= Math.max(offers.length - 3, 0) ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        if (offers.length <= 3) return;
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? Math.max(offers.length - 3, 0) : prevIndex - 1
        );
    };

    // Touch handlers
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 75) nextSlide();
        if (touchStart - touchEnd < -75) prevSlide();
    };

    // Get visible offers
    const getVisibleOffers = () => {
        if (offers.length <= 3) return offers;

        const visibleOffers = offers.slice(currentIndex, currentIndex + 3);

        if (visibleOffers.length < 3) {
            visibleOffers.push(...offers.slice(0, 3 - visibleOffers.length));
        }

        return visibleOffers;
    };

    const visibleOffers = getVisibleOffers();

    // Loading state with timeout
    if (loading) {
        return (
            <div style={{
                marginBottom: '32px',
                padding: isMobile ? '0 16px' : '0 24px',
                textAlign: 'center',
                minHeight: '300px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '20px'
            }}>
                <div style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #FF6B35',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <div>
                    <h3 style={{ color: '#666', marginBottom: '8px' }}>Loading Offers...</h3>
                    <p style={{ color: '#999', fontSize: '14px' }}>
                        Fetching special offers for you
                    </p>
                    <button
                        onClick={() => {
                            setLoading(false);
                            setError('Loading timed out');
                        }}
                        style={{
                            marginTop: '15px',
                            padding: '8px 16px',
                            background: '#f0f0f0',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Cancel Loading
                    </button>
                </div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // Error state
    // if (error) {
    //     return (
    //         <div style={{
    //             marginBottom: '32px',
    //             padding: isMobile ? '16px' : '24px',
    //             background: '#ffebee',
    //             borderRadius: '12px',
    //             textAlign: 'center'
    //         }}>
    //             <h3 style={{ color: '#c62828', marginBottom: '10px' }}>⚠️ Unable to Load Offers</h3>
    //             <p style={{ color: '#666', marginBottom: '15px' }}>{error}</p>
    //             <button
    //                 onClick={fetchOffersData}
    //                 style={{
    //                     padding: '10px 20px',
    //                     background: '#b15cd6',
    //                     color: 'white',
    //                     border: 'none',
    //                     borderRadius: '6px',
    //                     cursor: 'pointer',
    //                     fontWeight: 'bold'
    //                 }}
    //             >
    //                 Try Again
    //             </button>
    //         </div>
    //     );
    // }

    // No offers
    // if (offers.length === 0) {
    //     return (
    //         <div style={{
    //             marginBottom: '32px',
    //             padding: isMobile ? '0 16px' : '0 24px',
    //             textAlign: 'center',
    //             minHeight: '200px',
    //             display: 'flex',
    //             flexDirection: 'column',
    //             alignItems: 'center',
    //             justifyContent: 'center'
    //         }}>
    //             <div style={{
    //                 width: '80px',
    //                 height: '80px',
    //                 background: '#f5f5f5',
    //                 borderRadius: '50%',
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 marginBottom: '16px'
    //             }}>
    //                 <span style={{ fontSize: '32px', color: '#999' }}>🎁</span>
    //             </div>
    //             <h3 style={{ color: '#666', marginBottom: '8px' }}>No Special Offers Available</h3>
    //             <p style={{ color: '#999', fontSize: '14px', marginBottom: '20px', maxWidth: '400px' }}>
    //                 Currently there are no paid offers available. Check back later!
    //             </p>
    //             <button
    //                 onClick={fetchOffersData}
    //                 style={{
    //                     padding: '10px 20px',
    //                     background: '#f0f0f0',
    //                     color: '#666',
    //                     border: '1px solid #ddd',
    //                     borderRadius: '6px',
    //                     cursor: 'pointer',
    //                     fontWeight: '600'
    //                 }}
    //             >
    //                 Refresh
    //             </button>
    //         </div>
    //     );
    // }

    // Render offers
    // Render offers - EXACT ORIGINAL LAYOUT
    return (
        <div style={{
            marginBottom: '32px',
            padding: isMobile ? '0 16px' : '0 24px',
            display: offers.length === 0 ? 'none' : 'block'  // Add this line
        }}>
            {/* Header with refresh button - ONLY SHOWS WHEN WE HAVE OFFERS */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px'
            }}>
                <h2 style={{
                    fontSize: '24px',
                    fontWeight: '700',
                    color: '#1F2937',
                    margin: 0
                }}>
                    Special Offers
                </h2>
            </div>

            {/* Carousel Container */}
            <div style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '20px',
                marginBottom: '20px'
            }}
                ref={carouselRef}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >

                {/* Offers Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : offers.length <= 2 ? `repeat(${Math.min(offers.length, 3)}, 1fr)` : 'repeat(3, 1fr)',
                    gap: '20px',
                    padding: '8px',
                    // Add this for single card centering
                    justifyContent: offers.length === 1 ? 'center' : 'stretch'
                }}>
                    {visibleOffers.map((offer) => (
                        <div
                            key={offer.id}
                            style={{
                                background: 'white',
                                borderRadius: '16px',
                                overflow: 'hidden',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                height: '100%',
                                // Add maxWidth for single card
                                maxWidth: offers.length === 1 ? '400px' : 'none',
                                width: offers.length === 1 ? '100%' : 'auto',
                                margin: offers.length === 1 ? '0 auto' : '0'
                            }}
                            onMouseEnter={(e) => {
                                if (!isMobile) {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.15)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isMobile) {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                                }
                            }}
                            onClick={() => {
                                // Add your click handler here
                            }}
                        >
                            {/* Food Image with Overlay */}
                            <div style={{
                                height: '300px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundImage: `url(${offer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    transition: 'transform 0.5s ease'
                                }}></div>

                                {/* Gradient Overlay */}
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%)'
                                }}></div>

                                {/* Discount Percentage */}
                                <div style={{
                                    position: 'absolute',
                                    top: '16px',
                                    right: '16px',
                                    background: 'linear-gradient(135deg, #FF6B35 0%, #FF9E00 100%)',
                                    color: 'white',
                                    fontSize: '18px',
                                    fontWeight: '800',
                                    padding: '10px 20px',
                                    borderRadius: '20px',
                                    boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)'
                                }}>
                                    {offer.discount}
                                </div>

                                {/* Item Name */}
                                <div style={{
                                    position: 'absolute',
                                    bottom: '16px',
                                    left: '16px',
                                    right: '16px',
                                    color: 'white',
                                    fontSize: '24px',
                                    fontWeight: '800',
                                    padding: '12px 20px',
                                    textAlign: 'center',
                                    textShadow: '0 2px 8px rgba(0,0,0,0.8)'
                                }}>
                                    {offer.name}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OffersSection;